import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import TwilioVideoGoRoom from "../../../stream/twilio/TwilioVideoGoRoom";
import { setChannelProperty } from "actions/ui";

class Streams extends React.Component {

	constructor(props) {
		super(props);

		this.handleAvatarError = this.handleAvatarError.bind(this);
	}

	handleAvatarError(e) {
		e.target.src = this.props.configuration.baseDir + '/gfx/icons/user.png';
	}

	renderStream() {
		switch (this.props.stream.type) {
			case 'stream.video.twilio.room.go':
				return <TwilioVideoGoRoom
						stream={ this.props.stream }
						streamInfo={ <div className="wcStreamChannelDetails">
								{this.props.channel.avatar && <img src={ this.props.channel.avatar } onError={ this.handleAvatarError } className="wcFunctional wcAvatar" alt={this.props.channel.name} /> }
								<div className="wcStreamCaller">{ this.props.channel.name }</div>
							</div>
						}
						maximized={ this.props.uiChannel.streamMaximized }
						onMaximize={ () => this.props.setChannelProperty(this.props.channel.id, 'streamMaximized', true) }
						onMinimize={ () => this.props.setChannelProperty(this.props.channel.id, 'streamMaximized', undefined) }
				/>
			default:
				return 'Unsupported stream request';
		}
	}

	render() {
		if (!this.props.stream) {
			return null;
		}

		return(
			<div className="wcStream">
				{ this.renderStream() }
			</div>
		)
	}
}

Streams.propTypes = {
	channel: PropTypes.object.isRequired
};

export default connect(
	(state, ownProps) => ({
		configuration: state.configuration,
		stream: state.ui.streams.find( stream => stream.channel && stream.channel.id === ownProps.channel.id ),
		uiChannel: state.ui.channels[ownProps.channel.id] ?? {}
	}), { setChannelProperty }
)(Streams);